import { render, staticRenderFns } from "./view_FreeIssue.vue?vue&type=template&id=65e76fa8&scoped=true&"
import script from "./view_FreeIssue.vue?vue&type=script&lang=js&"
export * from "./view_FreeIssue.vue?vue&type=script&lang=js&"
import style0 from "./view_FreeIssue.vue?vue&type=style&index=0&id=65e76fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e76fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
